import { Component, OnInit } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { DateTimeUtilsService } from 'app/modules/common/services/date-time-utils.service';
import moment from 'moment';
import {
    TASK_TYPES,
    TreeView,
} from './task-type-tree-view/task-type-tree-view.component';

const _controlNames = {
    FPAFrom: 'FPAFrom',
    FPATo: 'FPATo',
    DiasFrom: 'DiasFrom',
    DiasTo: 'DiasTo',
    Gestor: 'Gestor',
    Coordinador: 'Coordinador',
};


@Component({
    selector: 'app-task-filter',
    templateUrl: './task-filter.component.html',
    styleUrls: ['./task-filter.component.scss'],
    standalone: false
})
export class TaskFilterComponent implements OnInit {
    DateFilterType = DateFilterTypes;
    ControlNames = _controlNames;
    PoblacionList:any=[];
    filteredProvinceList: any[] = [];
    filteredPoblacionList: any[] = [];
    public provinceList: Array<{ value: string; viewValue: string; }> | undefined;
    constructor(
        public selectionService: SelectionGenericService,
        public filterService: FilterService
    ) {}

    ngOnInit(): void {            
        this.initForm();
        this.getHardCodedList();
        this.selectionService.GestorList().subscribe(
            (res) => {
                if (res.code === 0) {
                    this.filterService.GestorList$ = res.result;
                }
            },
            (error) => {
                console.error(error);
            }
        );

        this.selectionService.GetCoordinatorList().subscribe(res => {
            if (res.code === 0) {
                this.filterService.CoordinadorList$ = res.result;
            }
        }, error => {
            console.error(error);
        });  

        if (this.filterService.PoblacionList == undefined){
        this.selectionService.PoblacionList().subscribe(
          (res) => {
            if (res.code === 0) {
              this.filterService.PoblacionList = res.result;
              this.filteredPoblacionList = [...this.filterService.PoblacionList];
            }
          },
          (error) => {
            console.error(error);
          }
        );
        }else{
        this.filteredPoblacionList = [...this.filterService.PoblacionList];
        }

    }

    private initForm() {
        const fpaFrom = this.selectionService.taskSelectionModal.FPAFromDate
            ? this.selectionService.taskSelectionModal.FPAFromDate
            : null;
        const fpaTo = this.selectionService.taskSelectionModal.FPAToDate
            ? this.selectionService.taskSelectionModal.FPAToDate
            : null;

        this.filterService.FPAFrom.setValue(fpaFrom);
        this.filterService.FPATo.setValue(fpaTo);
        this.filterService.DiasFrom.setValue(
            this.selectionService.taskSelectionModal.DiasFrom
        );
        this.filterService.DiasTo.setValue(
            this.selectionService.taskSelectionModal.DiasTo
        );

        const types = !this.selectionService.taskSelectionModal.LeaveType
            ? null
            : this.selectionService.taskSelectionModal.LeaveType.split(',');
        this.filterService.LeaveType.setValue(types);

        this.filterService.TaskGestor.setValue(this.selectionService.taskSelectionModal.Gestor);
        this.filterService.TaskCoordinador.setValue(this.selectionService.taskSelectionModal.Coordinador);

        
    }

    public setSelectedActivityType(
        taskTypeNode: { original: TreeView },
        isSelected: boolean
    ): void {
        const taskTypes = this.selectionService.taskSelectionModal.TaskType;

        if (isSelected) {
            if (!taskTypes.find((x) => x.id === taskTypeNode.original.id)) {
                this.selectionService.taskSelectionModal.TaskType =
                    taskTypes.concat(taskTypeNode.original);
            }
        } else {
            this.selectionService.taskSelectionModal.TaskType =
                taskTypes.filter((x) => x.id !== taskTypeNode.original.id);
        }
    }


    getHardCodedList(): void {
        this.provinceList = [
            { value: 'ALAVA', viewValue: 'ALAVA' },
            { value: 'ALBACETE', viewValue: 'ALBACETE' },
            { value: 'ALICANTE', viewValue: 'ALICANTE' },
            { value: 'ALMERIA', viewValue: 'ALMERIA' },
            { value: 'ANDORRA', viewValue: 'ANDORRA' },
            { value: 'ASTURIAS', viewValue: 'ASTURIAS' },
            { value: 'AVILA', viewValue: 'AVILA' },
            { value: 'BADAJOZ', viewValue: 'BADAJOZ' },
            { value: 'BALEARES', viewValue: 'BALEARES' },
            { value: 'BARCELONA', viewValue: 'BARCELONA' },
            { value: 'BURGOS', viewValue: 'BURGOS' },
            { value: 'CACERES', viewValue: 'CACERES' },
            { value: 'CADIZ', viewValue: 'CADIZ' },
            { value: 'CANTABRIA', viewValue: 'CANTABRIA' },
            { value: 'CASTELLON', viewValue: 'CASTELLON' },
            { value: 'CEUTA', viewValue: 'CEUTA' },
            { value: 'CIUDAD REAL', viewValue: 'CIUDAD REAL' },
            { value: 'CORDOBA', viewValue: 'CORDOBA' },
            { value: 'CUENCA', viewValue: 'CUENCA' },
            { value: 'GIRONA', viewValue: 'GIRONA' },
            { value: 'GRANADA', viewValue: 'GRANADA' },
            { value: 'GUADALAJARA', viewValue: 'GUADALAJARA' },
            { value: 'GUIPUZCOA', viewValue: 'GUIPUZCOA' },
            { value: 'HUELVA', viewValue: 'HUELVA' },
            { value: 'HUESCA', viewValue: 'HUESCA' },
            { value: 'JAEN', viewValue: 'JAEN' },
            { value: 'LA CORUÑA', viewValue: 'LA CORUÑA' },
            { value: 'LAS RIOJA', viewValue: 'LAS RIOJA' },
            { value: 'LAS PALMAS', viewValue: 'LAS PALMAS' },
            { value: 'LEON', viewValue: 'LEON' },
            { value: 'LLEIDA', viewValue: 'LLEIDA' },
            { value: 'LUGO', viewValue: 'LUGO' },
            { value: 'MADRID', viewValue: 'MADRID' },
            { value: 'MALAGA', viewValue: 'MALAGA' },
            { value: 'MELILLA', viewValue: 'MELILLA' },
            { value: 'MURCIA', viewValue: 'MURCIA' },
            { value: 'NAVARRA', viewValue: 'NAVARRA' },
            { value: 'ORENSE', viewValue: 'ORENSE' },
            { value: 'PALENCIA', viewValue: 'PALENCIA' },
            { value: 'PONTEVEDRA', viewValue: 'PONTEVEDRA' },
            { value: 'SALAMANCA', viewValue: 'SALAMANCA' },
            {
                value: 'SANTA CRUZ DE TENERIFE',
                viewValue: 'SANTA CRUZ DE TENERIFE',
            },
            { value: 'SEGOVIA', viewValue: 'SEGOVIA' },
            { value: 'SEVILLA', viewValue: 'SEVILLA' },
            { value: 'SORIA', viewValue: 'SORIA' },
            { value: 'TARRAGONA', viewValue: 'TARRAGONA' },
            { value: 'TERUEL', viewValue: 'TERUEL' },
            { value: 'TOLEDO', viewValue: 'TOLEDO' },
            { value: 'VALENCIA', viewValue: 'VALENCIA' },
            { value: 'VALLADOLID', viewValue: 'VALLADOLID' },
            { value: 'VIZCAYA', viewValue: 'VIZCAYA' },
            { value: 'ZAMORA', viewValue: 'ZAMORA' },
            { value: 'ZARAGOZA', viewValue: 'ZARAGOZA' },
        ];
        this.filteredProvinceList = [...this.provinceList];
    }

     onProvinciaChange(valorProvincia: string): void {
    if (valorProvincia) {
      this.selectionService.taskSelectionModal.Poblacion = '';
    }
    this.selectionService.taskSelectionModal.Provincia = valorProvincia;
  }
  onPoblacionChange(valorPoblacion: any): void {
    if (valorPoblacion) {
      this.selectionService.taskSelectionModal.Provincia = '';
    }
    this.selectionService.taskSelectionModal.Poblacion = valorPoblacion;
  }

     filtrarProvincias(event: Event): void {
    const busqueda = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredProvinceList = this.provinceList.filter(prov => 
      prov.viewValue.toLowerCase().includes(busqueda)
    );
  }
  filtrarPoblaciones(event: Event): void {
    const busqueda = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredPoblacionList = this.filterService.PoblacionList.filter((pob: string) => 
      pob.toLowerCase().includes(busqueda) 
    );
  }

    public SetFilterValues(controlName: string, data: any) {
        switch (controlName + '') {
            case this.ControlNames.FPAFrom:
                this.selectionService.taskSelectionModal.FPAFromDate =
                    DateHelper.getUTCDateString(data);
                break;

            case this.ControlNames.FPATo:
                this.selectionService.taskSelectionModal.FPAToDate =
                    DateHelper.getUTCDateString(data);
                break;

            case this.ControlNames.DiasFrom:
                this.selectionService.taskSelectionModal.DiasFrom = data.target
                    .value
                    ? data.target.value
                    : null;
                break;

            case this.ControlNames.DiasTo:
                this.selectionService.taskSelectionModal.DiasTo = data.target
                    .value
                    ? data.target.value
                    : null;
                break;

            case this.ControlNames.Gestor:
                this.selectionService.taskSelectionModal.Gestor = data
                    ? data
                    : null;
                break;

            case this.ControlNames.Coordinador:
                this.selectionService.taskSelectionModal.Coordinador = data
                    ? data
                    : null;
                break;

            default:
                break;
        }
    }

    SetLeaveType(leaveTypeArray: any[]): void {
        let leaveTypes = '';
        if (leaveTypeArray !== null) {
            leaveTypeArray.forEach((leaveType) => {
                leaveTypes += leaveType + ',';
            });
        }

        this.selectionService.taskSelectionModal.LeaveType = leaveTypes.replace(
            /,\s*$/,
            ''
        );
    }
}
